<div
  [@dropdownFadeInOut]
  class="origin-top-right z-[1000] text-black flex flex-col justify-between w-screen h-screen md:top-full md:right-0 md:w-80 md:mt-1 md:h-[480px] bg-white dark:bg-slate-800 border border-slate-200 dark:border-slate-700 md:rounded shadow-lg"
>
  <!-- Close -->
  <app-button
    svgIcon="close"
    class="md:hidden absolute top-4 right-1"
    [variant]="'ghost'"
    (btnClick)="closePanel()"
  />

  <!-- Header -->
  <div class="flex justify-start gap-2 md:justify-between items-center p-4">
    <h3 class="ord-subtitle-1">Notifications</h3>

    <app-button
      svgIcon="mail-open"
      [variant]="'subdued'"
      [textColor]="'indigo'"
      (btnClick)="onMarkAllAsRead()"
    >
      <ng-template appButtonText> Mark all as read </ng-template>
    </app-button>
  </div>

  <!-- List -->
  <div
    class="flex-1 border border-y-gray-200 divide-y divide-gray-200 overflow-y-auto"
  >
    @if(loading()) {
    <div class="h-full flex justify-center items-center">
      <mat-progress-spinner mode="indeterminate" />
    </div>
    } @else if (notifications().length > 0) { @for(notification of
    notifications(); track notification.id) {
    <div
      class="p-4 hover:bg-indigo-50 cursor-pointer flex flex-col gap-2 min-w-0"
      (click)="goToNotificationPage(notification.id)"
    >
      <!-- Title -->
      <p class="flex-1 ord-subtitle-1 min-w-0 line-clamp-2">
        {{ notification.title }}
      </p>

      <!-- Date -->
      <span class="text-xs ord-text-gray ml-auto">
        {{ formatNotificationDate(notification.createdAt) }}
      </span>
    </div>
    } } @else {
    <div class="h-full flex items-center justify-center">
      <p class="ord-body-1">No unread notifications</p>
    </div>
    }
  </div>

  <!-- Footer -->
  <div class="text-center p-4">
    <app-button
      [variant]="'ghost'"
      [textColor]="'indigo'"
      (btnClick)="goToNotificationsPage()"
    >
      <ng-template appButtonText>See all notifications</ng-template>
    </app-button>
  </div>
</div>
